module.exports = __webpack_public_path__ + "img/prof5.706c309d.jpg";